export default "__VITE_PUBLIC_ASSET__06c90628__"